const THEME_STORAGE_KEY = "bs:ui-theme";

export function normalizeTheme(value) {
  return String(value || "").toLowerCase() === "dark" ? "dark" : "light";
}

export function applyThemeToDocument(nextTheme) {
  if (typeof document === "undefined") return normalizeTheme(nextTheme);
  const theme = normalizeTheme(nextTheme);
  document.documentElement.setAttribute("data-app-theme", theme);
  if (document.body) {
    document.body.setAttribute("data-app-theme", theme);
  }
  return theme;
}

export function readThemeFromStorage() {
  try {
    if (typeof window === "undefined") return "light";
    return normalizeTheme(window.localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return "light";
  }
}

export function persistTheme(nextTheme) {
  const theme = normalizeTheme(nextTheme);
  try {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    }
  } catch {}
  return theme;
}

export function clearThemePersisted() {
  try {
    if (typeof window !== "undefined") {
      window.localStorage.removeItem(THEME_STORAGE_KEY);
    }
  } catch {}
}

export function bootstrapTheme() {
  const theme = readThemeFromStorage();
  applyThemeToDocument(theme);
  return theme;
}
